module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Bold.ad799136.woff";